import React, {CSSProperties} from "react";
import {Collapse} from "antd";
import {ExpandIconPosition} from "antd/lib/collapse/Collapse";


export type JCollapseProps = {
    onChange?: (value: any) => void;
    style?: CSSProperties,
    className?: string,
    children?: JSX.Element | JSX.Element[],
    ghost?: boolean,
    bordered?: boolean,
    defaultActiveKey?: string[],
    expandIconPosition?: ExpandIconPosition,
    expandIcon?: any
}

/**
 * Blocco di scelta Collpase
 * @param onChange
 * @param style
 * @param className
 * @param children
 * @param ghost
 * @param bordered
 * @param defaultActiveKey
 * @param expandIconPosition
 * @param expandIcon
 * @constructor
 */
export const JCollapse = ({
                              style,
                              className,
                              onChange,
                              ghost = false,
                              bordered = false,
                              children,
                              defaultActiveKey,
                              expandIconPosition,
                              expandIcon
                          }: JCollapseProps) => {



    return (
            <Collapse
                style={style}
                className={className}
                defaultActiveKey={defaultActiveKey}
                onChange={onChange}
                ghost={ghost}
                bordered={bordered}
                expandIconPosition={expandIconPosition}
                expandIcon={expandIcon}
            >
                    {children}
            </Collapse>
    );
};